import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export interface FilterItemInterface {
    label: string;
    href: string;
}

export interface FiltersInterface {
    displayType: 'buttons' | 'select';
    filters: FilterItemInterface[];
    selectLabel?: string;
    currentFilterLabels?: string[];
    filterClass?: string;
}

export class Filters {
    static readonly DEFAULT_LABEL = 'Select';

    constructor(props?: FiltersInterface) {
        this._displayType = props?.displayType;
        this._filters = props?.filters;
        this._selectLabel = props?.selectLabel || Filters.DEFAULT_LABEL;
        this._currentFilterLabels = props?.currentFilterLabels || [];
        this._class = props?.filterClass;
    }

    private _displayType?: string;
    private _filters?: FilterItemInterface[];
    private _selectLabel?: string;
    private _currentFilterLabels?: string[];
    private _class?: string;

    private renderFilterButtons = () => {
        let filterButtons = '';
        for (let idx=0; idx< (this._filters || []).length; idx++) {
            const filterItem = this._filters![idx];
            let filterClass = '';
            let filterDisabled = '';
            let filterHref = filterItem.href;
            
            for (let fl=0; fl < (this._currentFilterLabels || []).length; fl++) {
                
                const currentActiveFilterLabel = this._currentFilterLabels![fl];
                if (filterItem.label === currentActiveFilterLabel) {
                    filterClass = ` active`;
                    filterHref = window.location.pathname;
                }
            }
            filterButtons += `<sl-button size='medium' href='${filterHref}' pill class='${filterClass} '${filterDisabled} >${filterItem.label}</sl-button>`
        }
        return html`${unsafeHTML(filterButtons)}`;
    }

    private renderFilterSelect = () => {
        let filterSelect = '';
        for (let idx=0; idx< (this._filters || []).length; idx++) {
            const filterItem = this._filters![idx];
            let filterClass = '';
            let filterOptions = '';

            for (let fl=0; fl < (this._currentFilterLabels || []).length; fl++) {

                const currentActiveFilterLabel = this._currentFilterLabels![fl];
                if (filterItem.label === currentActiveFilterLabel) {
                    filterClass = ` active`;
                    filterOptions += ` type='checkbox'`
                    filterOptions += ' disabled';
                    filterOptions += ' checked';
                }
            }
            
            filterSelect += `<sl-menu-item class='${filterClass}'${filterOptions} value='${filterItem.href}'>${filterItem.label}</sl-menu-item>`
        }
        return html`${unsafeHTML(filterSelect)}`;
    }

    renderFilters = () => {
        if (!this._filters || !this._filters.length) {
            return html``;
        }
        let filterResult = html``;
        if (this._displayType === 'buttons') {
            filterResult = html`<sl-button-group label="Filters">${this.renderFilterButtons()}</sl-button-group>`;
        } else if (this._displayType === 'select') {
            filterResult = html`<sl-dropdown>
                <sl-button slot="trigger" caret>${this._selectLabel}</sl-button>
                <sl-menu>${this.renderFilterSelect()}</sl-menu>
            </sl-dropdown>`;
        }

        return html`<div class="bg-filters ${this._class}">${filterResult}</div>`;
    }
}
